@use '@/styles/tokens' as *;

// Mirrors src/pages/orders/order-detail.page.module.scss so the shimmer occupies the
// same shape as the loaded content.
.page {
  display: flex;
  flex-direction: column;
  margin: -24px;
  height: 100%;
}

.header {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-8) var(--space-16) var(--space-6);
}

.contacts {
  display: flex;
  gap: var(--space-6);
}

.body {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-16);
  padding: var(--space-4) var(--space-8) var(--space-6) var(--space-16);
}

.main {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  min-width: 0;
}

.lineItem {
  display: flex;
  align-items: center;
  gap: var(--space-4);
}

.lineText {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
}

.totals {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  margin-top: var(--space-4);
}

.side {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.card {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  padding: var(--space-8);
  background: var(--surface-card);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-surface);
}

@include up(lg) {
  .body {
    grid-template-columns: minmax(0, 1.45fr) minmax(0, 1fr);
  }
}
